module.exports = __webpack_public_path__ + "img/num2.786d3edd.png";